import { useEffect, useMemo } from "react";
import { useQuery } from "react-query";
import { EntreprisesServices } from "$services";
import GenericSelect from "./GenericSelect";
import { CacheInvalidationAction } from "$utils/cache";

type Props = {
  onChange: (contactId, contact) => void;
  value: any;
  error?: boolean;
  multiple?: boolean;
  required?: boolean;
  disabled?: boolean;
  companyId?: string;
  label?: string;
  placeholder?: string;
  unstyled?: boolean;
  onDataFetched?: (options: any[]) => void;
};
function ContactSelect({
  disabled,
  companyId,
  label = "Contact",
  placeholder = "Sélectionnez un contact",
  unstyled = false,
  onDataFetched,
  ...props
}: Props) {
  const filters = useMemo(
    () => ({
      companyId,
      isActive: true,
    }),
    [companyId]
  );

  const { data: contacts = [], isLoading } = useQuery({
    queryKey: [CacheInvalidationAction.GET_USERS, filters],
    queryFn: () => EntreprisesServices.gethUsersByCompany(companyId),
    enabled: !!companyId,
    select: (response) => response.data || [],
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (contacts.length > 0 && onDataFetched) {
      onDataFetched(contacts);
    }
  }, [contacts, onDataFetched]);

  let placeholderText = companyId
    ? placeholder
    : "Vous devez d'abord sélectionner une entreprise";

  if (companyId && contacts.length === 0 && !isLoading) {
    placeholderText = "Aucun contact pour cette entreprise";
  }

  return (
    <GenericSelect
      valueKey="_id"
      label={unstyled ? placeholder : label}
      placeholder={placeholderText}
      disabled={disabled || contacts.length === 0 || isLoading}
      options={contacts || []}
      getOptionLabel={(option: any) =>
        `${option.firstname} ${option.lastname?.toUpperCase()}`
      }
      {...props}
    />
  );
}

export default ContactSelect;
